import { NavLink } from "react-router-dom";
import ItodoImage from "../../elements/itodo-img";
import { useState } from "react";
import { serviceData } from "../../../globals/serviceDetail";

function Header1() {
  const [isActive, setIsActive] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState("");

  const toggleNavClass = () => {
    setIsActive(!isActive);
    if (!isActive) {
      setActiveSubMenu(""); // Reset submenus when opening
    }
  };

  const handleSubMenuToggle = (menuName) => {
    setActiveSubMenu(activeSubMenu === menuName ? "" : menuName);
  };

  const getSubMenuStyles = (menuName) => {
    // Only apply inline transition styles when mobile menu is active
    if (!isActive) return {};

    const isOpen = activeSubMenu === menuName;
    return {
      display: "block",
      maxHeight: isOpen ? "2000px" : "0px",
      overflow: "hidden",
      transition: "max-height 0.5s ease-in-out, opacity 0.5s ease-in-out",
      opacity: isOpen ? 1 : 0,
      visibility: isOpen || !isActive ? "visible" : "hidden",
      backgroundColor: "#fff", // Force white background on mobile
      width: "100%", // Ensure full width
      boxShadow: isOpen ? "0px 10px 20px rgba(0,0,0,0.1)" : "none", // Optional shadow for better visibility
      zIndex: 9999,
      position: "relative",
      color: "#000",
      textAlign: "left"
    };
  };

  const getArrowStyle = (menuName) => {
    const isOpen = activeSubMenu === menuName;
    return {
      transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
      transition: "transform 0.3s ease"
    };
  };

  return (
    <>
      <header
        className={
          "header-style1 site-header  mobile-sider-drawer-menu " +
          (isActive ? "active" : "")
        }
      >
        <div className="top-bar">
          <div className="container">
            <div className="d-flex justify-content-between  align-content-center">
              <div className="sx-topbar-left">
                <ul className="e-p-bx">
                  <li>
                    <a href="mailto:info@infotraceanalytics.com">info@infotraceanalytics.com</a>
                  </li>
                  <li>
                    <a href="tel:254797435680"> + (254)797 435 680</a>
                  </li>
                </ul>
              </div>
              <div className="sx-topbar-right">
                <div className="top-bar-nav">
                  <ul>
                    <li>
                      <NavLink to="/about-us">About US</NavLink>
                    </li>
                    <li>
                      <NavLink to="/faq">FAQ's</NavLink>
                    </li>
                    <li>
                      <NavLink to="/contact-us">Contact Us</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sticky-header main-bar-wraper navbar-expand-lg">
          <div className="main-bar">
            <div className="container clearfix">
              <div className="logo-header">
                <div className="logo-header-inner logo-header-one">
                  <NavLink to="/">
                    <ItodoImage src="images/Logo.png" alt="" />
                  </NavLink>
                </div>
              </div>
              {/* NAV Toggle Button */}
              <button
                id="mobile-side-drawer"
                data-target=".header-nav"
                data-toggle="collapse"
                className="navbar-toggler collapsed"
                onClick={toggleNavClass}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar icon-bar-first" />
                <span className="icon-bar icon-bar-two" />
                <span className="icon-bar icon-bar-three" />
              </button>
              {/* EXTRA NAV */}
              <div className="extra-nav">
                <div className="extra-cell">
                  <ul className="list-unstyled social-bx d-flex flex-wrap align-content-center">
                    <li>
                      <a
                        href="https://www.facebook.com/InfotraceAnalytics/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="feather-facebook" />{" "}
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/InfotraceAnaly" target="_blank" rel="noreferrer">
                        <i className="feather-twitter" />{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/company/104618733/admin/dashboard/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="feather-linkedin" />{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/infotraceanalytics/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="feather-instagram" />{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/@infotracemedia5593"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="feather-youtube" />{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* EXTRA Nav */}
              {/* MAIN NAVIGATION */}
              <div className="header-nav navbar-collapse collapse d-flex justify-content-center collapse ">
                <ul className=" nav navbar-nav ">
                  <li className="active">
                    <NavLink to="/">Home</NavLink>
                  </li>
                  <li className={`has-child ${activeSubMenu === "company" ? "nav-active" : ""}`}>
                    <NavLink to="/about-us">Company</NavLink>
                    <div
                      className="submenu-toogle"
                      onClick={() => handleSubMenuToggle("company")}
                    >
                      <i className="fa fa-angle-right" style={getArrowStyle("company")}></i>
                    </div>
                    <ul className="sub-menu" style={getSubMenuStyles("company")}>
                      <li>
                        <NavLink to="/about-us">About Us</NavLink>
                      </li>
                      <li>
                        <NavLink to="/faq">Faq Page</NavLink>
                      </li>
                      <li>
                        <NavLink to="/gallery">Gallery</NavLink>
                      </li>
                    </ul>
                  </li>
                  <li className={`has-child ${activeSubMenu === "services" ? "nav-active" : ""}`}>
                    <NavLink to="/services">Services</NavLink>
                    <div
                      className="submenu-toogle"
                      onClick={() => handleSubMenuToggle("services")}
                    >
                      <i className="fa fa-angle-right" style={getArrowStyle("services")}></i>
                    </div>
                    <ul className="sub-menu" style={getSubMenuStyles("services")}>
                      {Object.entries(serviceData).map(([serviceKey, service]) => (
                        <li key={serviceKey}>
                          <NavLink to={`/services/detail/${serviceKey}`}>
                            <i className={`flaticon-${service.icon || "category"}`}></i>
                            {" "}{service.title}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li><NavLink to="/careers">Careers</NavLink></li>
                  <li>
                    <NavLink to="/blogs">Media</NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact-us">Contact Us</NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header1;
